export const DOMAIN = "swedish";
export const DEFAULT_LANGUAGE = "de";

export const convertCurrency = (price, fromCurrency, toCurrency) => {
  if (fromCurrency === toCurrency) {
    // Nema potrebe za konverzijom ako su valute iste
    return price;
  }

  let exchangeRate = 1; // Postavite početni kurs razmene

  // Direktan kurs razmene iz EUR u USD i obrnuto
  const rates = {
    "EUR->USD": 1.1,
    "USD->EUR": 1 / 1.1,
  };

  // Formiranje ključa za pristup odgovarajućem kursu razmene
  const rateKey = `${fromCurrency}->${toCurrency}`;

  // Ako postoji definisan kurs razmene za dati par valuta, koristite ga
  if (rates[rateKey]) {
    exchangeRate = rates[rateKey];
  }

  // Vršite konverziju cene koristeći odabrani kurs razmene
  let convertedPrice = price * exchangeRate;

  // Vraćanje konvertovane cene bez dodatnog zaokruživanja
  // Ovo može pomoći u smanjenju akumulacije grešaka prilikom višestrukih konverzija
  return convertedPrice;
};
export const currencyTags = {
  USD: "$",
  EUR: "€",
};
export const DEFAULT_CURRENCY = "EUR";

export const PRODUCT_CHUNK = 30; // koliko se prozivoda prikazuje odjednom

//CHECKOUT
export const paymentMethods = [
  { name: "Cash on Delivery", code: "cod", available: true },
  { name: "Credit Card", code: "card", available: false },
  // { name: "PayPal", code: "paypal", available: false },
];

export const transportMethods = [
  { name: "DHL Standard", price: 8.9, days: 5 },
  { name: "DHL Express Saver", price: 19.9, days: 2 },
];

export const freeShippingEligibleMethods = ["DHL Standard"];

export const freeShippingThreshold = 50; // Prag za besplatnu dostavu

export const qualifiesForFreeShipping = (subtotal, methodName) =>
  subtotal >= freeShippingThreshold &&
  freeShippingEligibleMethods.includes(methodName);

export const getShippingCostPrice = (
  selectedMethod,
  fromCurrency,
  toCurrency
) => {
  const method =
    transportMethods.find((m) => m.name === selectedMethod) ||
    transportMethods[0];
  return convertCurrency(method.price, fromCurrency, toCurrency);
};

export const languages = [
  {
    code: "de",
    label: "Deutsch",
    flag: require("../assets/icons/austria.svg").default,
  },
  {
    code: "en",
    label: "English",
    flag: require("../assets/icons/united-kingdom.svg").default,
  },
];

export const featured_categories = [{ name: "Velo" }, { name: "Skruf" }];
export const adminEmailList = [
  "djuricm13111@gmail.com",
  "djuricm888@gmail.com",
];
